import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class EqualPasswordValidator {
  constructor() {
    this.errorMessage = <FormattedMessage id="passwords_are_not_equal" />
  }

  validate() {
    return this.errorMessage
  }
}
